<template>
  <v-footer
    height="auto"
    class="grey darken-3 mt-5">
    <v-layout
      row
      wrap
      justify-center>
      <v-flex
        xs12
        py-3
        text-xs-center
        white--text>
        <v-btn
          v-for="share in shares"
          :key="share.name"
          :class="share.name"
          :href="share.href"
          target="_blank"
          class="white--text"
          flat
        >
          <font-awesome-icon :icon="share.icon"/>
          &nbsp;share
        </v-btn>
      </v-flex>

      <v-flex
        class="grey darken-4"
        xs6
        py-3
        text-xs-center
        white--text>
        <div class="title mb-2">Z&auml;hler</div>
        <ul class="footer-list">
          <li>
            <img
              :src="`https://img.shields.io/badge/%F0%9F%A6%81-${lionCounter}-brightgreen.svg?longCache=true&style=flat`"
              alt="Bruell Zaehler"
            >
          </li>
          <li
            v-for="counter in counters"
            :key="counter.name"
          >
            <img
              :src="`https://img.shields.io/badge/${counter.name}-${counter.number}-${counter.color}.svg?longCache=true&style=flat`"
              :alt="counter.name"
            >
          </li>
        </ul>
      </v-flex>

      <v-flex
        class="grey darken-4"
        xs6
        py-3
        text-xs-center
        white--text>
        <div class="title mb-2">Links</div>
        <ul class="footer-list">
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/tabelle">Tabelle</router-link></li>
          <li><router-link to="/immer-loewe">#ELIL</router-link></li>
          <li><router-link to="/impressum">Impressum</router-link></li>
        </ul>
      </v-flex>

      <v-flex
        class="grey darken-4"
        xs12
        py-3
        text-xs-center
        white--text>
        &copy;2018 — <strong><a
          class="white--text"
          href="http://www.webcore-it.com">Web Core
          IT</a></strong>
      </v-flex>
    </v-layout>
  </v-footer>


</template>


<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faFacebook, faPinterest, faTwitter } from '@fortawesome/fontawesome-free-brands';

export default {
  name: 'ElilFooter',
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      shares: [
        {
          name: 'facebook',
          icon: faFacebook,
          href: 'https://www.facebook.com/sharer/sharer.php?u=www.einmal-loewe.de',
        },
        {
          name: 'twitter',
          icon: faTwitter,
          href: 'https://twitter.com/home?status=Ja%20do%20schaug%20her%3A%20www.einmal-loewe.de',
        },
        {
          name: 'pinterest',
          icon: faPinterest,
          href: 'https://pinterest.com/pin/create/button/?url=www.einmal-loewe.de&media=www.einmal-loewe.de/static/img/der-loewe.a628899.svg&description=Ja%20do%20schaug%20her%3A%20www.einmal-loewe.de',
        },
      ],
      counters: [
        { name: 'Facebook', number: 97, color: '3b5998' },
        { name: 'Twitter', number: 12, color: '3B5998' },
        { name: 'Pinterest', number: 65, color: 'BD081C' },
      ],
    };
  },
  computed: {
    lionCounter() {
      return this.$root.lionCounter.counter;
    },
  },
};
</script>

<style lang="scss" scoped>
  .footer-list {
    margin: 0;
    padding: 0;
    list-style: none;


    a {
      color: white;
    }
  }
  /*.facebook {*/
  /*color: #3b5998;*/
  /*}*/

  /*.twitter {*/
  /*color: #3B5998;*/
  /*}*/

  /*.pinterest {*/
  /*color: #BD081C;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/ElilFooter.vue